import ApplicationRulesList from './ApplicationRulesList';

export default {
  list: ApplicationRulesList,
};
